export default __webpack_public_path__ + "static/media/tofy-bnb.5f34a236.png";